var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16821_97432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 48.1208 48.1208 35 31 35C13.8792 35 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31Z",
    fill: "url(#paint0_linear_16821_97432)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16821_97432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.733 30.3013C33.4176 33.7189 28.5824 33.7189 27.267 30.3013L22.7003 18.4368C21.6918 15.8167 23.6258 13 26.4334 13L35.5666 13C38.3742 13 40.3082 15.8167 39.2997 18.4368L34.733 30.3013Z",
    fill: "url(#paint1_linear_16821_97432)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16821_97432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5587 44.0656C33.0714 46.9638 28.9286 46.9638 27.4413 44.0656L20.1337 29.8263C18.7676 27.1645 20.7005 24 23.6924 24L38.3076 24C41.2995 24 43.2324 27.1645 41.8663 29.8263L34.5587 44.0656Z",
    fill: "url(#paint2_linear_16821_97432)",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16821_97432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1206 58.1084C32.5194 60.1052 29.4806 60.1052 27.8794 58.1083L14.5634 41.5023C12.4639 38.884 14.3279 35 17.6841 35L44.3159 35C47.6721 35 49.5361 38.884 47.4366 41.5023L34.1206 58.1084Z",
    fill: "url(#paint3_linear_16821_97432)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16821_97432",
    x: -1.57043,
    y: -5,
    width: 65.1409,
    height: 67.8643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16821_97432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16821_97432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16821_97432",
    x: -4.31287,
    y: 6,
    width: 70.6257,
    height: 70.2393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16821_97432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16821_97432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16821_97432",
    x: -10.3235,
    y: 17,
    width: 82.647,
    height: 72.606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16821_97432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16821_97432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16821_97432",
    x1: 62,
    y1: -3.41188,
    x2: 21.4523,
    y2: 54.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16821_97432",
    x1: 29.3333,
    y1: 27,
    x2: 81.5663,
    y2: 3.9052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16821_97432",
    x1: 28.7778,
    y1: 38,
    x2: 90.5633,
    y2: 1.57536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16821_97432",
    x1: 27.5278,
    y1: 49,
    x2: 97.9046,
    y2: -15.8273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF0D3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16821_97432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLarge);
export default __webpack_public_path__ + "static/media/downloadLarge.2a2b65192438f2769ffdc38b44415b0b.svg";
export { ForwardRef as ReactComponent };